module.exports = __webpack_public_path__ + "img/tag1.d54f07ec.png";